import { MY_ACCOUNT_URL } from '@in-life/constants';

import {
  clearBasketStorage,
  clearFormPersistStorage,
} from '@utils/storagePropertyManagement';

const clearInLifeOrder = () => {
  clearFormPersistStorage();
  clearBasketStorage();
};

const clearInLifeOrderAndRedirectToMyAccount = () => {
  clearInLifeOrder();
  window.location.href = MY_ACCOUNT_URL;
};

export { clearInLifeOrder, clearInLifeOrderAndRedirectToMyAccount };
